import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import Analytics from "@/assets/icons/analytics.svg";
import ArrowDown from "@/assets/icons/arrow_down.svg";
import Assess from "@/assets/icons/assess.svg";
import Back from "@/assets/icons/back.svg";
import Base from "@/assets/icons/base.svg";
import Bell from "@/assets/icons/bell.svg";
import Billing from "@/assets/icons/billing.svg";
import CloseRoundLight from "@/assets/icons/Close_round_light.svg";
import CloseSubtract from "@/assets/icons/CloseSubtract.svg";
import CollapseListAll from "@/assets/icons/Collapse_list_all.svg";
import CopyAlt from "@/assets/icons/Copy_alt.svg";
import Calendar from "@/assets/icons/calendar.svg";
import Chats from "@/assets/icons/chats.svg";
import Chevron from "@/assets/icons/chevron.svg";
import ChevronDouble from "@/assets/icons/chevrondouble.svg";
import DoneRound from "@/assets/icons/Done_round.svg";
import Dark from "@/assets/icons/dark.svg";
import Dnd from "@/assets/icons/dnd.svg";
import Download from "@/assets/icons/download.svg";
import ExpandDown from "@/assets/icons/Expand_down.svg";
import ExpandLeft from "@/assets/icons/Expand_left.svg";
import ExpandListAll from "@/assets/icons/Expand_list_all.svg";
import EditIconSvg from "@/assets/icons/edit.svg";
import EmailIcon from "@/assets/icons/email.svg";
import EqualWeight from "@/assets/icons/equalWeight.svg";
import Exit from "@/assets/icons/exit.svg";
import FireFill from "@/assets/icons/Fire_fill.svg";
import File from "@/assets/icons/file.svg";
import Fork from "@/assets/icons/fork.svg";
import GainWeight from "@/assets/icons/gainWeight.svg";
import Globe from "@/assets/icons/globe.svg";
import Home from "@/assets/icons/home.svg";
import InfoFill from "@/assets/icons/Info_fill.svg";
import Invitations from "@/assets/icons/invitations.svg";
import Kebab from "@/assets/icons/kebab.svg";
import Know from "@/assets/icons/know.svg";
import LabResults from "@/assets/icons/lab_results.svg";
import LockIcon from "@/assets/icons/lock.svg";
import LooseWeight from "@/assets/icons/looseWeight.svg";
import MoonAlt from "@/assets/icons/Moon_alt.svg";
import MealPlan from "@/assets/icons/meal_plan.svg";
import MedicalHistory from "@/assets/icons/medical_history.svg";
import NewestFilters from "@/assets/icons/newestfilters.svg";
import Patient from "@/assets/icons/patient.svg";
import Photo from "@/assets/icons/photo.svg";
import ProfileInformation from "@/assets/icons/profile_information.svg";
import Question from "@/assets/icons/question.svg";
import Refresh2IconSvg from "@/assets/icons/Refresh_2.svg";
import RefreshIconSvg from "@/assets/icons/refresh.svg";
import SettingAltFill from "@/assets/icons/Setting_alt_fill.svg";
import StatusList from "@/assets/icons/Status_list.svg";
import Sun from "@/assets/icons/Sun.svg";
import SearchIcon from "@/assets/icons/search.svg";
import Setting from "@/assets/icons/setting.svg";
import SortDown from "@/assets/icons/sort_down.svg";
import TimeAtackFill from "@/assets/icons/Time_atack_fill.svg";
import Trash from "@/assets/icons/Trash.svg";
import UserFill from "@/assets/icons/User_fill.svg";
import VisitNotes from "@/assets/icons/visit_notes.svg";
import WarningIcon from "@/assets/icons/warning.svg";
export var IconSize;
(function (IconSize) {
    IconSize[IconSize["large"] = 0] = "large";
    IconSize[IconSize["medium"] = 1] = "medium";
    IconSize[IconSize["small"] = 2] = "small";
    IconSize[IconSize["extraSmall"] = 3] = "extraSmall";
})(IconSize || (IconSize = {}));
export const Icon = memo(function Icon(props) {
    const { name, properties = {}, size, fill } = props;
    const sizePx = useMemo(() => {
        switch (size) {
            case IconSize.large:
                return 24;
            case IconSize.medium:
                return 20;
            case IconSize.small:
                return 16;
            case IconSize.extraSmall:
                return 12;
        }
        return undefined;
    }, [size]);
    if (sizePx) {
        properties.width = sizePx;
        properties.height = sizePx;
    }
    // Добавляем fill в properties, если передан проп fill
    if (fill) {
        properties.fill = fill;
    }
    // Создаем иконку
    const iconElement = (() => {
        switch (name) {
            case "chevron-double":
                return _jsx(ChevronDouble, Object.assign({}, properties));
            case "chevron":
                return _jsx(Chevron, Object.assign({}, properties));
            case "bell":
                return _jsx(Bell, Object.assign({}, properties));
            case "back":
                return _jsx(Back, Object.assign({}, properties));
            case "base":
                return _jsx(Base, Object.assign({}, properties));
            case "calendar":
                return _jsx(Calendar, Object.assign({}, properties));
            case "chats":
                return _jsx(Chats, Object.assign({}, properties));
            case "assess":
                return _jsx(Assess, Object.assign({}, properties));
            case "dark":
                return _jsx(Dark, Object.assign({}, properties));
            case "exit":
                return _jsx(Exit, Object.assign({}, properties));
            case "close-round-light":
                return _jsx(CloseRoundLight, Object.assign({}, properties));
            case "close-subtract":
                return _jsx(CloseSubtract, Object.assign({}, properties));
            case "analytics":
                return _jsx(Analytics, Object.assign({}, properties));
            case "lab-results":
                return _jsx(LabResults, Object.assign({}, properties));
            case "meal-plan":
                return _jsx(MealPlan, Object.assign({}, properties));
            case "medical-history":
                return _jsx(MedicalHistory, Object.assign({}, properties));
            case "moon-alt":
                return _jsx(MoonAlt, Object.assign({}, properties));
            case "profile-information":
                return _jsx(ProfileInformation, Object.assign({}, properties));
            case "question":
                return _jsx(Question, Object.assign({}, properties));
            case "visit-notes":
                return _jsx(VisitNotes, Object.assign({}, properties));
            case "file":
                return _jsx(File, Object.assign({}, properties));
            case "billing":
                return _jsx(Billing, Object.assign({}, properties));
            case "patient":
                return _jsx(Patient, Object.assign({}, properties));
            case "photo":
                return _jsx(Photo, Object.assign({}, properties));
            case "user-fill":
                return _jsx(UserFill, Object.assign({}, properties));
            case "setting":
                return _jsx(Setting, Object.assign({}, properties));
            case "search":
                return _jsx(SearchIcon, Object.assign({}, properties));
            case "email":
                return _jsx(EmailIcon, Object.assign({}, properties));
            case "lock":
                return _jsx(LockIcon, Object.assign({}, properties));
            case "arrow-down":
                return _jsx(ArrowDown, Object.assign({}, properties));
            case "expand-down":
                return _jsx(ExpandDown, Object.assign({}, properties));
            case "expand-left":
                return _jsx(ExpandLeft, Object.assign({}, properties));
            case "expand-list-all":
                return _jsx(ExpandListAll, Object.assign({}, properties));
            case "fire-fill":
                return _jsx(FireFill, Object.assign({}, properties));
            case "fork":
                return _jsx(Fork, Object.assign({}, properties));
            case "collapse-list-all":
                return _jsx(CollapseListAll, Object.assign({}, properties));
            case "done-round":
                return _jsx(DoneRound, Object.assign({}, properties));
            case "download":
                return _jsx(Download, Object.assign({}, properties));
            case "globe":
                return _jsx(Globe, Object.assign({}, properties));
            case "home":
                return _jsx(Home, Object.assign({}, properties));
            case "invitations":
                return _jsx(Invitations, Object.assign({}, properties));
            case "know":
                return _jsx(Know, Object.assign({}, properties));
            case "warning":
                return _jsx(WarningIcon, Object.assign({}, properties));
            case "loose-weight":
                return _jsx(LooseWeight, Object.assign({}, properties));
            case "gain-weight":
                return _jsx(GainWeight, Object.assign({}, properties));
            case "equal-weight":
                return _jsx(EqualWeight, Object.assign({}, properties));
            case "info-fill":
                return _jsx(InfoFill, Object.assign({}, properties));
            case "setting-alt-fill":
                return _jsx(SettingAltFill, Object.assign({}, properties));
            case "status-list":
                return _jsx(StatusList, Object.assign({}, properties));
            case "sort-down":
                return _jsx(SortDown, Object.assign({}, properties));
            case "sun":
                return _jsx(Sun, Object.assign({}, properties));
            case "kebab":
                return _jsx(Kebab, Object.assign({}, properties));
            case "time-atack-fill":
                return _jsx(TimeAtackFill, Object.assign({}, properties));
            case "newest-filters":
                return _jsx(NewestFilters, Object.assign({}, properties));
            case "copy-alt":
                return _jsx(CopyAlt, Object.assign({}, properties));
            case "trash":
                return _jsx(Trash, Object.assign({}, properties));
            case "dnd":
                return _jsx(Dnd, Object.assign({}, properties));
            case "edit":
                return _jsx(EditIconSvg, Object.assign({}, properties));
            case "refresh":
                return _jsx(RefreshIconSvg, Object.assign({}, properties));
            case "refresh-2":
                return _jsx(Refresh2IconSvg, Object.assign({}, properties));
        }
    })();
    return iconElement;
});
